import {
  Breadcrumb,
  BreadcrumbItem,
} from "lcm-iot-commons/client/lib/components/Breadcrumb";
import { IntlShape, useIntl } from "react-intl";
import {
  SignUpBreadcrumbLabels,
  SignInTermsBreadcrumbLabels,
} from "../../context/SignUpContext";

const buildBreadCrumb = (
  intl: IntlShape,
  current: string | undefined,
  action: string,
) => {
  const items =
    (action &&
      (action === "signup"
        ? SignUpBreadcrumbLabels
        : SignInTermsBreadcrumbLabels)) ||
    [];

  return items.map((item: { key: string }) => (
    <BreadcrumbItem
      className="breadcrumb-item-eh-style breadcrumb-not-focused"
      focus={item.key === current}
      key={item.key}
      title={intl.formatMessage({ id: `${action}.breadcrumb.${item.key}` })}
    />
  ));
};

type OwnProps = {
  current?: string;
  action: string;
};

const defaultProps: Partial<OwnProps> = {
  current: undefined,
};

type Props = OwnProps & typeof defaultProps;

export default function SignUpBreadcrumb({ current, action }: Props) {
  const intl = useIntl();
  const breadcrumb = buildBreadCrumb(intl, current, action);

  return <Breadcrumb id="sign-up-header">{breadcrumb}</Breadcrumb>;
}

SignUpBreadcrumb.defaultProps = defaultProps;
